import React from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import useElementObserver from 'hooks/useElemetObserver';
import useGetJobs from 'hooks/useJobs';
import useGetUserStatistics from 'hooks/useUserStatistics';
import { isEmptyValues } from 'utils/helpers';
import { getSampleJob } from 'hooks/useRunABJob';
import Loading from 'components/system/Loading';
import UserProfile from './UserProfile';
import StatisticsSection from './StatisticsSection';
import QuickLinks from './QuickLinks';
import ActionButton from './ActionButton';
import BottomAnimation from './BottomAnimation';
import styles from './userHome.styles';

const UserHome = () => {
  const navigate = useNavigate();
  const { isElementPresent: hasBanner, isLoading: isBannerLoading } = useElementObserver('banner');
  const { isLoading, ...stats } = useGetUserStatistics();
  const { total, isLoading: isJobsLoading } = useGetJobs(0, 10);
  const sampleJob = getSampleJob() || null;

  const allValuesAreEmpty = isEmptyValues(stats, '0ms');

  const noJobRuns = sampleJob?.jobId && total === 1;
  return (
    isBannerLoading ? <Container><Loading /></Container> : (
      <Container sx={{ overflow: 'auto', paddingBottom: '10px', minWidth: '905px' }} className="userHome">
        <Box sx={styles.container(hasBanner)} className="userHome__container">
          <UserProfile />
          <ActionButton
            navigate={navigate}
            sampleJob={sampleJob}
            noJobRuns={noJobRuns}
            allValuesAreEmpty={allValuesAreEmpty}
            isLoading={isJobsLoading && isLoading}
          />
        </Box>
        <StatisticsSection stats={stats} navigate={navigate} isLoading={isLoading} hasBanner={hasBanner} />
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <BottomAnimation />
          </Grid>
          <Grid item xs={6}>
            <QuickLinks navigate={navigate} />
          </Grid>
        </Grid>
      </Container>
    )
  );
};

export default UserHome;
